<template>
  <div>
    <div class="container">
      <el-form
        ref="skuForm"
        :rules="rules"
        :model="newForm"
        class="form-content"
        size="small"
      >
        <div>
          <div
            v-for="(item, index) in newForm.recordsNew"
            class="table-content"
          >
            <div class="top">
              <div class="top-header-left">
                <div>需求计划编号：</div>
                {{ item.purchaseDemandCode }}
                <div style="margin-left: 20px">需求计划名称：</div>
                {{ item.purchaseDemandName }}
              </div>
              <div class="top-header-right">
                <div>
                  <div class="approver">
                    申请人：
                    <span>{{ item.createMemberName }}</span>
                  </div>
                </div>
                <div class="order-status-text">
                  申请时间：{{ item.createTime }}
                </div>
              </div>
            </div>
            <el-table
              :show-header="false"
              :data="item.purchaseDemandItemSelectedListVOS"
              border
              max-height="455"
              style="width: 100%"
              :header-cell-style="{
                background: '#F5F5F5',
                borderColor: '#d9d9d9',
              }"
              :cell-style="{ borderColor: '#d9d9d9' }"
              current-row-key="index"
              class="validate-table"
              align="center"
              fit
            >
              <el-table-column label="序号" width="50px" align="center">
                <template #default="scope">
                  <div class="choose-btn">
                    <span>{{ scope.$index + 1 }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="物料描述"
                min-width="190px"
                prop="productName"
                align="center"
              >
                <template #default="scope">
                  <div class="item-content">
                    <div class="label">物料描述</div>
                    <!-- <p>{{ scope.row.categoryDesc }}</p> -->
                    <div
                      class="item-img-content-name in2clamp"
                      style="line-height: 16px; -webkit-line-clamp: 4"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.categoryDesc"
                        placement="top"
                      >
                        <div class="font break">
                          <div class="font break">
                            {{ scope.row.categoryDesc }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="需求数量"
                min-width="156px"
                prop="quantity"
                align="center"
              >
                <template #default="{ row }">
                  <div class="item-unit">
                    <div class="item-row">
                      <div class="item-row-column margin-r10">
                        <div class="item-row-column-desc">需求数量</div>
                        <div class="item-row-column-content">
                          {{ row.quantity }}
                        </div>
                      </div>
                      <div class="item-row-column margin-r10">
                        <div class="item-row-column-desc">计量单位</div>
                        <div class="item-row-column-content">
                          {{ row.baseUnitName }}
                        </div>
                      </div>
                      <div class="item-row-column">
                        <div
                          class="item-row-column-desc"
                          style="color: #e50113"
                        >
                          剩余可采购数量
                        </div>
                        <div
                          class="item-row-column-content"
                          style="color: #e50113"
                        >
                          {{ row.remainingQuantity }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="商品"
                min-width="272px"
                prop="remainingQuantity"
                align="center"
              >
                <template #default="{ row }">
                  <div
                    class="item-img-content"
                    v-if="row.purchaseDemandItemSkuSelectedListVOS"
                  >
                    <div class="item-img-content-top">
                      <div class="item-img-content-row">
                        <div
                          class="item-img-content-column"
                          style="border: 1px solid #d9d9d9"
                        >
                          <img
                            v-lazy="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productImageUrl
                            "
                            :src="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productImageUrl
                            "
                            alt=""
                            class="img-relative"
                          />
                        </div>
                        <div
                          v-if="row.purchaseDemandItemSkuSelectedListVOS"
                          class="item-img-content-column"
                        >
                          <div
                            class="item-img-btn"
                            @click="handleSelectProduct(row)"
                          >
                            修改商品
                          </div>
                        </div>
                      </div>
                      <div
                        class="item-img-content-row"
                        style="margin-left: 10px"
                      >
                        <div
                          class="item-img-content-column"
                          style="margin-bottom: 12px"
                        >
                          <div class="item-img-content-name in2clamp">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="
                                row.purchaseDemandItemSkuSelectedListVOS[0]
                                  .productSkuName
                              "
                              placement="top"
                            >
                              <div class="font break">
                                <div class="font break">
                                  {{
                                    row.purchaseDemandItemSkuSelectedListVOS[0]
                                      .productSkuName
                                  }}
                                </div>
                              </div>
                            </el-tooltip>
                          </div>
                        </div>

                        <div class="item-img-content-column">
                          <div
                            v-if="
                              row.purchaseDemandItemSkuSelectedListVOS &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode.length <= 38
                            "
                            class="item-img-content-name"
                            style="color: #999999; line-height: 1"
                          >
                            商品编码：{{
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode
                            }}
                          </div>
                          <el-tooltip
                            v-if="
                              row.purchaseDemandItemSkuSelectedListVOS &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode.length > 38
                            "
                            class="item"
                            effect="dark"
                            :content="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode
                            "
                            placement="top"
                          >
                            <div
                              class="item-img-content-name in3clamp"
                              style="color: #999999; line-height: 1"
                            >
                              商品编码：{{
                                row.purchaseDemandItemSkuSelectedListVOS[0]
                                  .productSkuCode
                              }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="choose-btn">
                    <eui-btn @click="handleSelectProduct(row)"
                      >选择商品</eui-btn
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="采购数量"
                min-width="112px"
              >
                <template #default="scope" >
                  <div class="num-box">
                    <el-form-item
                            :prop="`recordsNew[${index}].purchaseDemandItemSelectedListVOS[${scope.$index}].purchaseNum`"
                            :rules="rules.purchaseNum"
                    >
                      <div class="purchase-number" style="margin-bottom: 10px">
                        采购数量
                      </div>
                      <el-input
                              v-model.trim="scope.row.purchaseNum"
                              :disabled="
                        !scope.row.purchaseDemandItemSkuSelectedListVOS
                      "
                              maxlength="10"
                              size="small"
                              placeholder="请输入"
                              @change="
                        handleNumChange(
                          scope.row,
                          scope.row.purchaseDemandItemSkuSelectedListVOS[0],
                          scope.$index
                        )
                      "
                      ></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="108px">
                <template #default="{ row }">
                  <!-- <span
                  :class="{
                    'is-active':
                      underlineName == '删除' &&
                      underlineOrderId == item.orderId,
                  }"
                  
                >
                  删除
                </span> -->
                  <div class="delete">
                    <eui-btn type="text" @click="handleDelete(row)"
                      >删除</eui-btn
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <!-- <div
      v-if="isFixed"
      class="button-handle is-fixed"
      style="z-index: 1000; background-color: #ffffff; height: 60px"
    >
      <div class="is-fixed-wrap-left"></div>
      <div class="is-fixed-wrap">
        <div class="reset" @click="handleCancel">取 消</div>
        <div class="query" @click="handleOrder">生成订单</div>
      </div>
    </div> -->
    </div>
    <div id="show-btn" class="button-handle">
      <eui-btn type="secondary" @click="handleCancel">返回</eui-btn>
      <div>
        <eui-btn type="secondary" @click="handleCancel">取消</eui-btn>
        <eui-btn @click="handleOrder">生成订单</eui-btn>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/modules/projectA/utils/utils';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import Api from '@/modules/projectA/api/purchase/index';
import { orderBaseUrl } from '@/modules/projectA/api/config';

export default {
  name: 'AllOrder',
  components: { eDialog },
  props: {
    changeOrderHandle: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      tipWord: '',
      checkCompanyAttrFlag: false,
      dialogType: '',
      isDoc: '',
      dialogContent: '',
      underlineName: '',
      underlineOrderId: '',
      orderStatusNum: '',
      onLinePayAndCompanyPay: '', // 在线支付与担保支付组合
      listLoading: false,
      noDataFlag: false,
      resData: {},
      formInline: {
        projectnos: null, // 采购申请号 目前没有
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        time: null,
        startTime: null,
        endTime: null,
        memberRealName: null, // 下单人姓名
        shipmentType: null, // 配送方式 1：配送　　2：自提
        orderStatus: null,
        otherPay: 0, // 0不使用1使用易权通
        endAmount: null,
        startAmount: null,
        pageNum: 1,
        pageSize: 5,
      },
      records: [],
      form: {},
      tableData: [],
      rules: {
        purchaseNum: [
          { validator: this.validatePurchaseNum, trigger: ['blur', 'change'] },
        ],
        categoryDesc: {
          required: true,
          message: '请输入名称',
          trigger: 'blur',
        },
      },
      count: 1,
      busy: true,
      productSearch: {
        skuname: '', // 精确查
        skucode: '', // 商品编号
        suppliercompanyname: '', // 供应商
        pageNum: 1,
        pageSize: 5,
      },
      isFixed: true,
      purchaseRow: {},
      taxInfo: {},
      purchaseDemandIdList: '',
      recordsIndex: 0,
      newForm: {
        recordsNew: [],
      },
    };
  },
  created() {
    this.selectOrder();
    this.getOrderList();
  },
  /* mounted() {
    this.checkShow();
    window.addEventListener('scroll', this.initHeight);
  }, */
  /* destroyed() {
    window.removeEventListener('scroll', this.initHeight);
  }, */
  methods: {
    validatePurchaseNum(rule, value, callback) {
      console.log(rule, 'rule', value);
      let remainingQuantity = 0;
      const attr = rule.field;
      const regex = /\[(.+?)\]/g;
      const arr = attr.match(regex);
      for (let i = 0; i < arr.length; i++) {
        arr[i] = JSON.parse(arr[i]);
      }
      // const [first, last] = arr;
      const first = arr[0][0];
      const last = arr[1][0];
      console.log(first, last);
      const item =
        this.newForm.recordsNew[first].purchaseDemandItemSelectedListVOS[last];
      remainingQuantity = item.remainingQuantity;
      /* const ruleArr = rule.field.split(".");
      console.log(ruleArr);
      const index = ruleArr[1];
      console.log(index);
      console.log(ruleArr[2], "ruleArr[1]"); */

      /* console.log(rule.field, 'rule');
        const ruleArr = rule.field.split('.');
        console.log(ruleArr);
        const index = ruleArr[2];
        const item = this.formData.tableData[index];
        remainingQuantity = item.remainingQuantity; */
      /* const item = this.records[this.recordsIndex].purchaseDemandItemSelectedListVOS[index];
      console.log(item, "item");
      remainingQuantity = item.remainingQuantity; */

      if (!value || value == 0) {
        return callback(new Error('请输入采购数量'));
      }
      if (!/^-?\d+(\.\d{1,3})?$/.test(value)) {
        return callback(new Error('采购数量为保留三位小数'));
      }
      console.log(value, remainingQuantity);
      if (value > remainingQuantity) {
        return callback(new Error(`采购数量小于等于剩余采购数量`));
        // return callback(new Error(`采购数量最多${remainingQuantity}`));
      }
      callback();
    },
    initHeight() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // scrollTop = scrollTop+634;
      // console.log(scrollTop, '这是scrollTop');
      // let height =  document.documentElement.clientHeight || document.body.clientHeight;
      // let scorllHeight =  document.body.scrollHeight  ||document.documentElement.scrollHeight;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      // console.log(height, 'height');
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      if (scrollTop + height < divToTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    checkShow() {
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (height + scrollTop > divToTop) {
        this.isFixed = false;
      } else {
        this.isFixed = true;
      }
    },
    // 查询
    async selectOrder() {
      this.listLoading = true;
      const res = await Api.queryProductPage2({
        ...this.productSearch,
      });
      this.listLoading = false;
      if (res.code == '200') {
        this.tableData = this.tableData.concat(res.data.list); // 数组拼接，得到拼接后的数据
        this.total = res.data.list.length;
        if (res.data.list.length == 0) this.busy = true;
        else this.busy = false;
      } else {
        this.$message.error(res.message);
      }
    },

    loadMore() {
      this.busy = true;
      // 把busy置位true，这次请求结束前不再执行
      setTimeout(() => {
        // 订单列表
        this.productSearch.pageNum = this.count++;
        this.busy = true;
        this.selectOrder();
        // 调用获取数据接口，并且传入一个true，让axios方法指导是否需要拼接数组。
      }, 500);
    },
    handleCancel() {
      this.$router.push({ path: '/demand/execute' });
    },
    handleOrder() {
      this.$refs.skuForm.validate((val) => {
        if (val) {
          // window.open(
          //   `${purchaseUrl}/order?flag=requestPool&purchaseDemandIdList=${this.purchaseDemandIdList}`,
          //   '_blank'
          // );

          window.open(`${orderBaseUrl}/order?from=v&flag=requestPool&purchaseDemandIdList=${this.purchaseDemandIdList}`, '_blank');
        }

        /* this.$router.push({
            path: '/order',
            query: { flag: 'requestPool', purchaseDemandIdList: this.purchaseDemandIdList },
          }); */
      });
      /* if (flag) {
        this.$router.push({
          path: "/order",
          query: { flag: "requestPool", purchaseDemandIdList: this.purchaseDemandIdList },
        });
      }  */
    },
    handleReset() {
      this.productSearch.skuname = '';
      this.productSearch.skucode = '';
      this.productSearch.suppliercompanyname = '';
    },
    async handleSearch() {
      this.productSearch.pageNum = 1;
      const res = await Api.queryProductPage2({
        ...this.productSearch,
      });
      if (res.code == '200') {
        this.tableData = res.data.list; // 数组拼接，得到拼接后的数据
        if (res.data.list.length == 0) this.busy = true;
        else this.busy = false;
      } else {
        this.$message.error(res.message);
      }
    },
    handleSelectionChange() {},
    async handleSelected(val) {
      // 获得税率信息
      const param = {
        taxRateId: val.taxrateid,
      };
      const res1 = await Api.getProductRate(param);

      if (res1.code == '200') {
        this.taxInfo = res1.data;

        const params = {
          // purchaseDemandProductChooseAO :{
          brandName: val.brandname,
          categoryId: val.categoryid,
          categoryName: val.category,
          conversionUnitRatio: '',
          price: val.price,
          productId: val.productid,
          productImageUrl: val.defaultimage,
          productSkuCode: val.skucode,
          productSkuId: val.skuid,
          productSkuName: val.skuname,
          protocolCode: '',
          purchaseCompanyId: val.suppliercompanyid,
          purchaseCompanyName: val.suppliercompanyname,
          purchaseDemandId: this.purchaseRow.purchaseDemandId,
          purchaseDemandItemId: this.purchaseRow.purchaseDemandItemId,
          purchaseQuantity: this.purchaseRow.purchaseQuantity,
          salesTaxNo: this.taxInfo.taxRateCode,
          salesTaxRate: this.taxInfo.taxRate,
          subtotal: '',
          supplierCompanyId: val.suppliercompanyid,
          supplierCompanyName: val.suppliercompanyname,
          unitCode: '',
          unitName: val.unitvalue,
          productSkuOptionsStr: val.specificationstr,
          productSkuOptions: val.specificationsList,
          purchaseDemandCode: this.purchaseRow.purchaseDemandCode,
          // }
        };

        const res = await Api.choosePurchaseDemandProductPc(params);

        if (res.code == '200') {
          this.visible = false;
          this.getOrderList();
        }
      }
    },
    handleSelectProduct(item) {
      this.purchaseRow = item;
      // this.visible = true;
      this.$router.push({
        path: '/demand/execute/selectGoods',
        query: {
          purchaseDemandItemId: item.purchaseDemandItemId,
        },
      });

      // purchaseDemandId:item.purchaseDemandId,
      //   purchaseQuantity:item.purchaseQuantity,
      //   purchaseDemandCode:item.purchaseDemandCode,
    },

    async getOrderList() {
      const params = {};
      const res = await Api.queryPurchaseDemandSelectPc(params);
      const goods = [];
      res.data.forEach((item) => {
        /* const itemProduct = item.purchaseDemandItemSelectedListVOS[0];
        goods.push(itemProduct);
        if (itemProduct?.purchaseDemandItemSkuSelectedListVOS?.length) {
          item.purchaseDemandItemSelectedListVOS[0].purchaseNum =
            item.purchaseDemandItemSelectedListVOS[0]?.purchaseDemandItemSkuSelectedListVOS[0]
              ?.purchaseQuantity || "";
        } */

        const itemProducts = item.purchaseDemandItemSelectedListVOS;
        itemProducts.forEach((product) => {
          goods.push(product);
          if (product.purchaseDemandItemSkuSelectedListVOS?.length) {
            product.purchaseNum =
              product?.purchaseDemandItemSkuSelectedListVOS[0]
                ?.purchaseQuantity || product.remainingQuantity;
            if (
              product?.purchaseDemandItemSkuSelectedListVOS[0]
                ?.purchaseQuantity === 0
            ) {
              Api.queryPurchaseNumPc({
                purchaseDemandItemSkuId:
                  product?.purchaseDemandItemSkuSelectedListVOS[0]
                    .purchaseDemandItemSkuId,
                purchaseQuantity: product.remainingQuantity,
              });
            }
          }
        });
      });
      this.purchaseDemandIdList = JSON.stringify(
        goods.map((item) => item.purchaseDemandItemId)
      );
      this.records = res.data;
      this.newForm.recordsNew = [...res.data];
    },
    async handleDelete(val) {
      console.log(val, '删除参数');
      const params = {
        isSelected: 0,
        purchaseCompanyId: val.purchaseCompanyId,
        purchaseDemandItemId: val.purchaseDemandItemId,
      };

      const res = await Api.deletePurchaseDemandItemPc(params);

      if (res.code == '200') {
        this.$message({
          type: 'success',
          message: '删除成功',
        });
        this.getOrderList();
      }
    },
    async getRateInfo(val) {
      const params = {
        taxRateId: val,
      };
      const res = await Api.getProductRate(params);

      if (res.code == '200') {
        this.taxInfo = res.data;
        console.log('this.taxInfo', this.taxInfo);
      }
    },
    async handleNumChange(value, skuItem, index) {
      /* console.log(value, skuItem, index, 'handleNumChange'); */
      const params = {
        purchaseDemandItemSkuId: skuItem.purchaseDemandItemSkuId,
        purchaseQuantity: value.purchaseNum,
      };
      const res = await Api.queryPurchaseNumPc(params);
    },
  },
};
</script>
<style lang="scss">
.el-tooltip__popper {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.table-content {
  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
}
.form-content {
  line-height: 1;
  &:first-child {
    margin-top: 0;
  }
  ::v-deep .el-table--border {
    &::after {
      background: #d9d9d9;
    }
  }
  ::v-deep .el-table {
    .el-table__cell {
      height: 110px;
    }
    .cell {
      height: 100%;
      text-align: left;
      .item-content {
        line-height: 1;
        .label {
          margin-bottom: 8px;
          color: #999;
        }
        p {
          line-height: 18px;
        }
      }
      .el-form-item {
        display: flex;
        justify-content: center;
        font-size: 12px;
        .el-form-item__label {
          padding: 0px 0 0px;
          line-height: 1;
        }
        .el-form-item__error {
          padding-top: 6px;
        }
        .el-form-item--small.el-form-item {
          padding-bottom: 30px;
        }
        .el-form-item__content {
          font-size: 12px;
          line-height: 1;
        }
      }
      .num-box{
        height: 100%;
        display: flex;
        align-items: center;
        margin-top: 8px;
      }
      .delete {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .purchase-number::before {
        content: '*';
        color: red;
      }
    }
    border-color: #d9d9d9;
    &::before {
      background: #d9d9d9;
    }
    .el-table--border {
      &::after {
        background: #d9d9d9;
      }
    }
  }
}

.top {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f5f5f5;
  border: 1px solid $border-color;
  border-bottom: none;
  font-size: 12px;
  color: #333;
  .top-header-left {
    color: #333333;
    font-weight: 700;
    display: flex;
  }
  .top-header-right {
    display: flex;
    justify-items: center;
    .approver {
      display: flex;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .order-status-text {
      color: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
  }
}
.item-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 1;
  .item-row-column {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    .item-row-column-desc {
      white-space: nowrap;
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #999999;
      margin-bottom: 8px;
    }
    .item-row-column-content {
      line-height: 16px;
      font-size: 12px;
      color: #333333;
    }
  }
}
.item-img-content {
  .item-img-content-top {
    display: flex;
    align-items: flex-start;
    .item-img-content-row {
      height: 70px;
      display: flex;
      font-size: 12px;
      flex-direction: column;
      justify-content: space-between;
      .item-img-content-column {
        line-height: 1;
        .item-img-btn {
          font-size: 12px;
          line-height: 1;
          color: #0064c8;
          margin-top: 10px;
          text-align: center;
          cursor: pointer;
        }
        .img-relative {
          display: block;
          width: 68px;
          height: 68px;
        }
        .img-absolute {
          width: 20px;
          height: 25px;
          position: absolute;
          left: 6px;
          top: 0;
        }
        .item-img-content-name {
          font-size: 12px;
          line-height: 16px;

          color: #333333;
        }
      }
      li:nth-child(2) {
        margin: 0 10px;
      }
      li:nth-child(3) {
        margin-right: 10px;
      }
    }
  }
}

.choose-btn {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-handle {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  margin-top: 20px;

  &.is-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  .is-fixed-wrap-left {
    width: 180px;
    height: 100%;
  }
  .is-fixed-wrap {
    margin-left: 10px;
    width: 1040px;
    /* margin: 0 auto; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
